export enum LoadingKeys {
  maintenanceMode = 'maintenanceMode',
  Login = 'login',
  ResetPassword = 'ResetPassword',
  ConcreteTypes = 'ConcreteTypes',
  ConcreteMix = 'ConcreteMix',
  TechnicalScreen = 'TechnicalScreen',
  ClientSensor = 'ClientSensor',
  ClientBananas = 'ClientBananas',
  Projects = 'Projects',
  ProjectDetails = 'ProjectDetails',
  MarkPourAsDone = 'MarkPourAsDone',
  ExportPourDetails = 'ExportPourDetails',
  CreateOrUpdatePour = 'CreateOrUpdatePour',
  PourGaugeDetails = 'PourGaugeDetails',
  ProjectDashboard = 'ProjectDashboard',
  PourSensors = 'PourSensors',
  UpdateInfo = 'PourSensors',
  DeleteSensor = 'DeleteSensor',
  toggleEnableSensor = 'toggleEnableSensor',
  GetSensorDetails = 'GetSensorDetails',
  GetFinishSensorDetails = 'GetFinishSensorDetails',
  UpdateSensor = 'UpdateSensor',
  GetSensorIdFromQr = 'GetSensorIdFromQr',
  GetBananaIdFromQr = 'GetBananaIdFromQr',
  GetHubIdFromQr = 'GetHubIdFromQr',
  UploadHubImage = 'UploadHubImage',

  CheckLifeSign = 'CheckLifeSign',
  AddSensor = 'AddSensor',
  SwitchDevice = 'SwitchDevice',
  EditSensor = 'EditSensor',
  AddHub = 'AddHub',

  pwaVersion = 'pwaVersion',
  DeleteHub = 'DeleteHub',
  EditHub = 'EditHub',
  psiConcreteTypes = "psiConcreteTypes",
  GetCustomers = 'GetCustomers',
  GetMaturityConcretes = 'GetMaturityConcretes',
  AddMaturityConcrete = 'AddMaturityConcrete',
  AddMaturityConcretePress = 'AddMaturityConcretePress',
  CalcMaturityParams = 'CalcMaturityParams',
}
